import React from 'react';
import { LoginForm } from './LoginForm';
import logo from '../../assets/images/kinetic-data-logo.svg';

export const LoginScreen = props => (
  <div className="app-wrapper">
    <div className="login-container border-top border-dark border-12">
      <div className="pb-4 text-center">
        <div>
          <img src={logo} alt="Kinetic Data" />
        </div>
        <div className="badge badge-sm bg-dark text-border rounded-4 mt-2">
          System Console
        </div>
      </div>
      <LoginForm {...props}>
        {({ usernameField, passwordField, loginButton, ssoButton }) => (
          <>
            {usernameField}
            {passwordField}
            {props.error && (
              <div className="alert alert-danger">{props.error}</div>
            )}
            <div className="login-button">{loginButton}</div>
            {ssoButton && (
              <>
                <hr className="my-4 bg-secondary opacity-100" />
                <div className="login-button">{ssoButton}</div>
              </>
            )}
          </>
        )}
      </LoginForm>
    </div>
  </div>
);
